import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { Panel } from 'src/Components'
import { GemGrid } from 'src/Components/shared/Gem'
import { Waypoint } from 'react-waypoint'
import { ScrolledIntoView, EVENTS_LABELS } from 'src/constants/trackingEvents'
import { oneTimeTagEventDispatcher } from 'src/helpers/tagManager'
import { OVERLAY_HELPERS } from 'src/constants/navigation'

import styles from './PurchasingPower.module.scss'

const scrollIntoView = oneTimeTagEventDispatcher(ScrolledIntoView, {
  eventLabel: EVENTS_LABELS.PurchasingPowerModule
})

const PurchasingPower = ({
  className,
  gems,
  showDetail,
  selectedDetail,
  selectedGem,
  show,
  hide,
  question,
  topic,
  intl
}) => (
  <Panel
    data-qa='PurchasingPowerCard'
    className={classnames(className, styles.card)}
  >
    <Panel.Heading className={styles.heading} id='purchasingPower'>
      <FormattedMessage
        id='Homeowner.purchasePower.heading'
        defaultMessage='If you bought another home, how much could you afford?'
      />
    </Panel.Heading>
    <Waypoint onEnter={scrollIntoView} bottomOffset='75%'>
      <div />
    </Waypoint>
    <GemGrid
      className={styles.grid}
      horizontal
      data={gems}
      selectedDetail={selectedDetail}
      selectedGem={selectedGem}
      show={show}
      hide={hide}
      collapsed={showDetail}
      question={question}
      topic={topic}
      disableCospoMessage
      overlayPanelName={OVERLAY_HELPERS.purchasing.overlay}
      overlayPanelFrom={OVERLAY_HELPERS.purchasing.getOrigin()}
      overlayPanelTitle={OVERLAY_HELPERS.getTitle('purchasing', intl)}
    />
  </Panel>
)

export default PurchasingPower
